import PATH from '../paths';

const name = 'Neuma Investments';
const key = 'neuma';
const imgUrl = `${ PATH.CDN }/whitelabels/neuma`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-neuma-blue:               #0f1d81;
    --color-neuma-purple:             #831a88;

    --color-primary:                  var(--color-neuma-blue);
    --color-secondary:                var(--color-darker);
    --color-accent:                   var(--color-neuma-purple);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              transparent;
    --anonymous-copy-bg:              var(--color-primary);
    --anonymous-heading-color:        var(--color-white);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          50px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-primary);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-xusa-blueLight);

    --sidebar-button-color: var(--color-white);
    --sidebar-button-color-active: var(--color-primary);
    --sidebar-button-color-hover: var(--color-primary);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-white);
    --sidebar-button-bg-color-hover: var(--color-white);
    --sidebar-button-border-color: var(--color-white);
    --sidebar-button-border-color-active: var(--color-white);
    --sidebar-button-border-color-hover: var(--color-white);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-accent);
    --btn-primary--border:            var(--color-accent);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-accent);
    --btn-primary--borderH:           var(--color-accent);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-accent);
    --btn-secondary--color:           var(--color-accent);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-accent);
    --btn-secondary--colorH:          var(--color-accent);

    /* END */


    /* FILTER BUTTONS */

    .p-button--switchboard--active {
      --button-text-color:                var(--color-white);
      --button-text-color-hover:          var(--color-white)!important;
      --switchboard-nav-figure-bg-color:  var(--color-white);
    }

    .c-switchboard__heading figure .m-icon {
      --switchboard-nav-figure-bg-color:  --button-text-color;
    }

    /* END */


    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
